<template>
    <router-link
        :to="backToAppRoute"
        class="flex items-center gap-x-2 h-9 mt-2 text-gray-370 dark:text-gray-110 hover:text-gray-370 dark:hover:text-white hover:bg-menu-purple70 dark:hover:bg-menu-blue770 transition-colors"
        :class="mini ? 'justify-center mx-auto w-9 !h-10 rounded-1.25' : 'mx-2 px-2 rounded-1.25'"
    >
        <BackToAppIcon class="w-5 h-5 text-gray-370 dark:text-gray-200" />

        <span
            v-if="!mini"
            class="text-xs whitespace-nowrap"
        >Back to App</span>
    </router-link>

    <div
        class="border-t border-gray-100 dark:border-gray-760 my-2"
        :class="mini ? 'mx-2' : 'mx-4'"
    ></div>

    <div class="flex flex-col pb-10">
        <div
            v-for="(group, index) in groups"
            :key="group.id"
        >
            <div
                v-if="index > 0"
                class="border-t border-gray-100 dark:border-gray-760 my-2"
                :class="mini ? 'mx-2' : 'mx-4'"
            ></div>

            <div
                v-if="!mini"
                class="flex items-center w-full px-4 py-2.5 text-gray-370 dark:text-gray-200 mb-1"
            >
                <span class="font-sans-inter text-xxxs font-medium uppercase whitespace-nowrap tracking-0.05em">
                    {{ group.section }}
                </span>
            </div>

            <div class="flex flex-col gap-y-0.5 text-gray-370 dark:text-gray-110">
                <CustomRouterLink
                    v-for="item in group.items"
                    :key="item.id"
                    class="relative h-9 flex items-center cursor-pointer transition-colors"
                    :class="[mini ? 'justify-center mx-auto w-9 !h-10 rounded-1.25' : 'mx-2 px-2 gap-x-3 rounded-1.25', itemStyle(item)]"
                    :route="item"
                    :mini="mini"
                    :simpleRote="true"
                >
                    <span
                        class="w-5 flex items-center justify-center"
                        :class="isActiveItem(item) ? 'text-purple dark:text-purple-140' : 'dark:text-gray-200'"
                    >
                        <component :is="item.icon()" />
                    </span>

                    <span
                        v-if="!mini"
                        class="text-xs font-normal whitespace-nowrap"
                    >
                        {{ item.name }}
                    </span>
                </CustomRouterLink>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import CustomRouterLink from '@/components/navigation/CustomRouterLink.vue'
import BackToAppIcon from '@/components/icons/BackToAppIcon.vue'

import { useAuthorizationStore } from '@/store/authorizationStore'
import { usePermissionsStore } from '@/store/permissionsStore'

import { SETTINGS_MENU_GROUPS } from '@/constants/settingsSidebarMenu'
import { ROUTES } from '@/constants/routes'

defineProps({
    mini: {
        type: Boolean,
        default: false,
    },
})

const route = useRoute()

const authorizationStore = useAuthorizationStore()
const permissionsStore = usePermissionsStore()

const groups = computed(() => SETTINGS_MENU_GROUPS
    .map((group) => ({
        ...group,
        items: group.items.filter((item) => !item.visible || permissionsStore.settingsAccess[item.visible]),
    }))
    .filter((group) => group.items.length))

function isActiveItem(item) {
    return route.meta.reference === item.routeName
}

function itemStyle(item) {
    return isActiveItem(item)
        ? 'bg-purple-50 dark:bg-menu-blue770 text-purple dark:text-purple-140'
        : 'hover:bg-menu-purple70 hover:text-gray-370 dark:hover:text-white dark:hover:bg-menu-blue770'
}

const backToAppRoute = computed(() => ({
    name: ROUTES.reporting,
    params: {
        workspace: authorizationStore.getWorkspaceSlug,
    },
}))
</script>
